import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  deleteRule: {
    id: `app.containers.WorkflowEditor.components.Rules.PartnerRules.PartnerRuleCard.deleteRule`,
    defaultMessage: 'Delete Rule',
  },
  dragRule: {
    id: `app.containers.WorkflowEditor.components.Rules.PartnerRules.PartnerRuleCard.dragRule`,
    defaultMessage: 'Drag rule {number}',
    description: 'Accessible label for the partner rule drag handle',
  },
  ruleNumber: {
    id: `app.containers.WorkflowEditor.components.Rules.PartnerRules.PartnerRuleCard.ruleNumber`,
    defaultMessage: 'Rule {number}',
  },
});
